import { React, useState } from "react";
import "./style.css";
import { MenuItem, Select } from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { Event } from "./Event";
import { useEffect } from "react";
export const CalendarBox = ({ DataDashboard, setEvent }) => {
  console.log(
    "dashboard//CalendarBox//events",
    DataDashboard?.DataDashboard?.events?.e
  );
  const [events, setEvents] = useState("");
  const handleChange = (event) => {
    setEvents(event.target.value);
  };

  const currentDate = new Date();
  const options = { day: "numeric", month: "short", weekday: "long" };
  const formattedDate = currentDate.toLocaleDateString("en-US", options);
  const [filterOption, setFilterOption] = useState("All");
  useEffect(() => {
    console.log("filterOption//filterOption", filterOption);
    setEvent(filterOption);
  }, [setEvent,filterOption]);
  return (
    <>
      <div
        className="CalenderDiv"
        style={{
          overflowY:
            DataDashboard?.events?.e.length > 2
              ? "scroll"
              : "hidden",
        }}
      >
        <div className="CalenderHeader">
          <div className="title">
            <div className="date-icon">
              <CalendarTodayIcon color="primary" />
            </div>
            <div className="full-date">
              <span style={{ fontWeight: "400 !important" }}>
                {formattedDate}
              </span>
              <br></br>
              <span style={{ color: "#BFBFBF" }}>Today</span>
            </div>
          </div>
          <div
            style={{ borderRadius: ".9rem", padding: "0px" }}
            className="events"
          >
            <Select
              sx={{
                boxShadow: "none",
                borderRadius: ".6rem",
                height: "2.5rem !important",
                width: "8rem",
                padding: "3rem",
                // padding: 0,
                ".MuiOutlinedInput-notchedOutline": {
                  border: "1px solid #F2F2F2",
                  padding: "0rem",
                },
                padding: "0px",
              }}
              value={events}
              onChange={handleChange}
              displayEmpty
            >
              <MenuItem
                onClick={() => {
                  setFilterOption("All");
                }}
                value=""
                sx={{ fontSize: ".9rem", color: "#333333" }}
              >
                All Events
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setFilterOption("webinar");
                }}
                value={5}
                sx={{ fontSize: ".9rem", color: "#333333" }}
              >
                Webinar
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setFilterOption("batch");
                }}
                sx={{ fontSize: ".9rem", color: "#333333" }}
                value={30}
              >
                Batch
              </MenuItem>
            </Select>
          </div>
        </div>
        <div className="event-component">
          {DataDashboard?.events?.e?.map((item, index) => {
            console.log("dashboard//events//item", item);

            if (
              filterOption === "All" ||
              (filterOption === "batch" && item.batchId) ||
              (filterOption === "webinar" && item.webinarPlatform)
            ) {
              return (
                <div key={index}>
                  <Event item={item} index={index} />
                </div>
              );
            }

            return null;
          })}
        </div>
      </div>
    </>
  );
};
